import React, { useContext, useEffect, useState } from "react";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChatIcon from "@mui/icons-material/Chat";
import { ProfileDetailsContext } from "../../context/ProfileDetailsProvider";
import { Link } from "react-router";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";

function Header() {
  const { profileDetails } = useContext(ProfileDetailsContext);
  const [detail, setDetail] = useState(profileDetails);

  useEffect(() => {
    setDetail(profileDetails);
  }, [profileDetails]);
  return (
    <div className="flex justify-between items-center p-4 bg-white shadow-md border-black border-b">
      <h2 className="text-4xl font-semibold">
        Hello {detail?.user?.firstname}
      </h2>
      <div className="flex items-center gap-4 pr-4">
        <Link to="chat">
          <ChatIcon className="hover:text-green-500 hover:cursor-pointer" />
        </Link>
        <SettingsRoundedIcon />
        {/* <Link to="profile">
          <AccountCircleIcon className=" hover:cursor-pointer" />
        </Link> */}
      </div>
    </div>
  );
}

export default Header;
